// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GoogleAuthResponse

export type GoogleAuthApiResponse = {
	id: number;
	email: string | null;
	name: string | null;
	picture: string | null;
};

export type GoogleAuth = {
	id: number;
	email: string | null;
	name: string | null;
	picture: string | null;
};

export function hydrateGoogleAuth(data: GoogleAuthApiResponse): GoogleAuth {
	return { ...data };
}